import { constants, cssVariableStyles } from "@newsela/angelou";

import { checksForUnderstandingFontSizes } from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";
const { generateIconColorCss } = cssVariableStyles;
const { ui } = constants.colors;

export const submitButtonCss = (
  currentFontSize: string = checksForUnderstandingFontSizes.small,
) => ({
  "&&": {
    fontSize:
      checksForUnderstandingFontSizes[
        currentFontSize as keyof typeof checksForUnderstandingFontSizes
      ],
  },
});

export const toastCss = {
  root: {
    margin: "100px 20px 0 20px",
  },
  cta: {
    background: "none",
    border: "none",
    fontWeight: "bold",
    color: ui.white[100],
    textDecoration: "underline",
    padding: 0,
    "&:hover": {
      background: "none",
    },
  },
};

export const iconCss = {
  ...generateIconColorCss({ primaryColor: ui.white[100] }),
};
